import { f as fetchCartData, s as sendAddToCart } from "./cart-DXzKAPAO.js";
import { f as formatMoney } from "./currency-DRNmrEpZ.js";
class QuickShopButton extends HTMLElement {
  constructor() {
    super();
    this.addToCartButton = null;
    this.closeQuickShopButton = null;
    this.quickShopModal = null;
    this.atcButton = null;
    this.soldOutToggles = [];
    this.soldOutButton = null;
    this.bisButton = null;
    this.bisPopupInitial = null;
    this.bisPopup = null;
    this.handleSoldOutToggle = (event) => {
      var _a, _b, _c, _d, _e;
      event.preventDefault();
      event.stopPropagation();
      const target = event.target.closest("[data-sold-out-toggle]") || event.target;
      (_a = this.soldOutToggles) == null ? void 0 : _a.forEach((toggle) => {
        if (toggle === target && toggle.classList.contains("is-selected")) {
          toggle.classList.remove("is-selected");
          return;
        }
        toggle.classList.toggle("is-selected", toggle === target);
      });
      const isSelected = target.classList.contains("is-selected");
      if (!isSelected) {
        this.showATC();
        return;
      } else {
        (_b = this.atcButton) == null ? void 0 : _b.classList.add("hidden");
        (_c = this.soldOutButton) == null ? void 0 : _c.classList.remove("hidden");
      }
      const bisEnabled = target.hasAttribute("data-show-bis");
      if (!this.bisButton || !this.bisPopup) {
        return;
      }
      (_d = this.bisPopup) == null ? void 0 : _d.setAttribute(
        "variant-id",
        target.getAttribute("data-variant-id") || ""
      );
      (_e = this.bisButton) == null ? void 0 : _e.classList.toggle("hidden", !(isSelected && bisEnabled));
    };
  }
  connectedCallback() {
    this.addEventListener("click", this.openQuickShop.bind(this));
  }
  async openQuickShop() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    this.quickShopModal = document.createElement("div");
    const cartData = await fetchCartData();
    const quickShopProduct = JSON.parse(
      this.getAttribute("data-product") || "{}"
    );
    let allVariantsMaxedOut = true;
    for (const variant of quickShopProduct.variants) {
      const variantId = variant.bundle_item ? variant.bundle_item.variants[0].id : variant.id;
      const variantInCart = cartData.items.find((item) => {
        if (parseInt(item.variant_id) === parseInt(variantId)) {
          return true;
        }
        return false;
      });
      if (variantInCart) {
        if (variant.max_quantity) {
          variant.max_quantity = variant.max_quantity - variantInCart.quantity;
          if (variant.max_quantity > 0) {
            allVariantsMaxedOut = false;
          }
          if (variant.max_quantity <= 0) {
            variant.min_quantity = 0;
          } else if (variant.min_quantity && variant.min_quantity > variant.max_quantity) {
            variant.min_quantity = 0;
          }
        } else if (variant.bundle_item_inventory) {
          variant.max_quantity = variant.bundle_item_inventory - variantInCart.quantity;
          if (variant.max_quantity > 0) {
            allVariantsMaxedOut = false;
          }
          if (variant.max_quantity <= 0) {
            variant.min_quantity = 0;
          } else if (variant.min_quantity && variant.min_quantity > variant.max_quantity) {
            variant.min_quantity = 0;
          }
        } else {
          variant.max_quantity = variant.inventory_quantity - variantInCart.quantity;
          if (variant.max_quantity > 0) {
            allVariantsMaxedOut = false;
          }
          if (variant.max_quantity <= 0) {
            variant.min_quantity = 0;
          } else if (variant.min_quantity && variant.min_quantity > variant.max_quantity) {
            variant.min_quantity = 0;
          }
        }
      } else {
        allVariantsMaxedOut = false;
      }
    }
    const quantityDecrement = (variantId) => {
      const input = document.querySelector(
        `.quickshop__variants #variant-${variantId}`
      );
      if (input && parseInt(input.value) > 0) {
        input.value = (parseInt(input.value) - 1).toString();
        window.setTimeout(() => {
          updateSubTotal();
        }, 200);
      }
    };
    const quantityIncrement = (variantId) => {
      const input = document.querySelector(
        `.quickshop__variants #variant-${variantId}`
      );
      quickShopProduct.variants.find(
        (variant) => variant.id === variantId
      );
      const maxQuantity = parseInt(input.max, 10);
      const currentValue = parseInt(input.value, 10);
      if (currentValue >= maxQuantity) {
        const variantGroup = input.closest(".product-swatches__form-group");
        if (variantGroup) {
          variantGroup.classList.add(
            "product-swatches__form-group--max-reached"
          );
          const maxQuantityMessage = "You've reached the max quantity";
          const existingError = document.querySelector(
            ".product-swatches__max-qty-error"
          );
          if (existingError) {
            existingError.remove();
          }
          const maxError = document.createElement("span");
          maxError.classList.add("product-swatches__max-qty-error");
          maxError.innerHTML = maxQuantityMessage;
          maxError.style.display = "block";
          maxError.style.color = "red";
          maxError.style.fontWeight = "bold";
          maxError.style.marginTop = "10px";
          maxError.style.marginBottom = "10px";
          maxError.style.position = "relative";
          maxError.style.zIndex = "10";
          variantGroup.insertAdjacentElement("afterend", maxError);
          setTimeout(() => {
            variantGroup.classList.remove(
              "product-swatches__form-group--max-reached"
            );
            maxError.remove();
          }, 3e3);
        }
        return;
      }
      if (parseInt(input.value) === 0) {
        input.value = "1";
        window.setTimeout(() => {
          updateSubTotal();
        }, 200);
      } else if (input && parseInt(input.value) < maxQuantity) {
        input.value = (parseInt(input.value) + 1).toString();
        window.setTimeout(() => {
          updateSubTotal();
        }, 200);
      }
      this.showATC();
    };
    const updateSubTotal = () => {
      let subTotal = 0;
      document.querySelectorAll(".product-swatches__quantity input").forEach((input) => {
        const inputElement = input;
        const price = inputElement.dataset.price ?? "0";
        let priceNoCurrency = price.replace(",", ".");
        priceNoCurrency = priceNoCurrency.replace(",", ".");
        priceNoCurrency = priceNoCurrency.replace("€", "");
        priceNoCurrency = priceNoCurrency.replace("£", "");
        priceNoCurrency = priceNoCurrency.replace("$", "");
        subTotal += parseInt(inputElement.value) * parseFloat(priceNoCurrency) * 100;
      });
      const quickshopSubtotal = document.getElementById("quickshop-subtotal");
      if (quickshopSubtotal) {
        quickshopSubtotal.innerText = "| " + formatMoney(subTotal);
      }
    };
    const handleAddToCart = async () => {
      await fetchCartData();
      const variantsToAdd = [];
      let exceedsMaxQuantity = false;
      let variantGroupWithError = null;
      console.log("variantsToAdd", variantsToAdd, quickShopProduct);
      document.querySelectorAll(".product-swatches__quantity input").forEach((input) => {
        const inputElement = input;
        if (parseInt(inputElement.value) > 0) {
          const variantId = inputElement.id.split("-")[1].toString();
          const inputMax = parseInt(inputElement.max, 10);
          const addQuantity = parseInt(inputElement.value, 10);
          const matchingVariant = quickShopProduct.variants.find(
            (variant) => variant.id.toString() === variantId
          );
          if (addQuantity > inputMax) {
            exceedsMaxQuantity = true;
            const closestGroup = inputElement.closest(
              ".product-swatches__form-group"
            );
            if (closestGroup instanceof HTMLElement) {
              variantGroupWithError = closestGroup;
            }
            return;
          }
          variantsToAdd.push({
            id: variantId,
            quantity: addQuantity,
            quantityAvailable: inputMax,
            properties: (matchingVariant == null ? void 0 : matchingVariant.pfand) ? { Pfand: matchingVariant.pfand } : {},
            selling_plan: "",
            pre_order: quickShopProduct.preOrder ? quickShopProduct.preOrder : false,
            pre_order_dispatch_eta: quickShopProduct.preOrderDispatchEta ? quickShopProduct.preOrderDispatchEta : ""
          });
        }
      });
      if (exceedsMaxQuantity) {
        const errorMessage = "You've reached the max quantity";
        const existingError = document.querySelector(
          ".product-swatches__max-qty-error"
        );
        if (existingError) {
          existingError.remove();
        }
        const maxError = document.createElement("span");
        maxError.classList.add("product-swatches__max-qty-error");
        maxError.style.display = "block";
        maxError.style.color = "red";
        maxError.style.fontWeight = "bold";
        maxError.style.marginTop = "10px";
        maxError.style.marginBottom = "10px";
        maxError.style.position = "relative";
        maxError.style.zIndex = "10";
        maxError.innerHTML = errorMessage;
        if (variantGroupWithError) {
          variantGroupWithError.insertAdjacentElement("afterend", maxError);
        } else {
          const variantsContainer = document.querySelector(
            ".quickshop__variants"
          );
          if (variantsContainer) {
            variantsContainer.insertAdjacentElement("afterend", maxError);
          } else {
            const quickshopContent = document.querySelector(
              ".quickshop__content"
            );
            quickshopContent == null ? void 0 : quickshopContent.appendChild(maxError);
          }
        }
        setTimeout(() => {
          maxError.remove();
        }, 3e3);
        return;
      }
      if (variantsToAdd == null ? void 0 : variantsToAdd.length) {
        sendAddToCart(variantsToAdd).then(() => {
          closeQuickShopButton();
        });
        return;
      }
      const currentOpenQuickShop = document.querySelector(".quickshop");
      if (!currentOpenQuickShop) {
        return;
      }
      currentOpenQuickShop.classList.add("quickshop--no-quantity");
    };
    const closeQuickShopButton = () => {
      const quickshopElement = document.querySelector(".quickshop");
      if (quickshopElement) {
        quickshopElement.remove();
      }
    };
    let img = quickShopProduct.images[0].src;
    if (img === void 0) {
      img = quickShopProduct.images[0];
    }
    quickShopProduct.variants.forEach((variant) => {
      if (variant.bundle_item) {
        const hasBundleAndQuantity = !variant.bundle_item.available;
        variant.availabilityClass = variant.bundle_item && hasBundleAndQuantity ? "product-swatches__form-group--sold-out" : "";
        variant.id = variant.bundle_item.variants[0].id;
        variant.quantityAvailable = variant.bundle_item_inventory;
        variant.available = variant.bundle_item.available;
      } else if (variant.available === false) {
        variant.availabilityClass = "product-swatches__form-group--sold-out";
        variant.hasBundleAndQuantity = false;
      }
      if (variant.millilitres) {
        variant.milText = `${window.themeVars.strings.product.from} ${variant.millilitres} / liter`;
      }
    });
    let soldOutButton = `
    <button
      type="button"
      class="quickshop__atc-button btn btn-white btn-white--outline ${quickShopProduct.available ? "hidden" : ""}"
      data-sold-out-button
    >
      <span>
        ${window.themeVars.strings.product.soldOut}
      </span>
    </button>
  `;
    let soldOutButtonHidden = quickShopProduct.available ? "hidden" : "";
    if (quickShopProduct.variants.length === 1 && quickShopProduct.variants[0].available === false) {
      soldOutButtonHidden = "";
    }
    if (!quickShopProduct.available && quickShopProduct.bis_enabled && quickShopProduct.tags && quickShopProduct.tags.includes("back-in-stock")) {
      soldOutButton = `
       <button
            type="button"
            class="quickshop__atc-button btn btn-white btn-white--outline ${soldOutButtonHidden}"
            data-bis-trigger
          >
            <span>
              ${window.themeVars.strings.product.notifyMe}
            </span>
          </button>
    `;
    }
    const quickShopContent = `
      <div class="quickshop">
        <div class="quickshop__overlay"></div>
        <div class="quickshop__content">
          <div class="quickshop__header">
            <img src="${img}" alt="${quickShopProduct.title}" />
            <h2 class="quickshop__title">${quickShopProduct.title}</h2>
            <button class="quickshop__close">
              ${window.themeVars.icons.close}
            </button>
          </div>
          <legend class="product-swatches__label">
            ${window.themeVars.strings.product.selectQuantities}
          </legend>
          ${window.themeVars.customer.staff && !quickShopProduct.compare_at_price ? `
            <p class="quickshop__staff-member-badge staff-member-badge">
              <span>${window.themeVars.icons.checkmark}</span>
              ${window.themeVars.strings.product.staffDiscount}
            </p>
            ` : window.themeVars.customer.efpMember && !quickShopProduct.compare_at_price ? `
            <p class="quickshop__efp-member-badge efp-member-badge">
              <span>${window.themeVars.icons.checkmark}</span>
              ${window.themeVars.strings.product.efpDiscount}
            </p>
            ` : ""}
          <div class="quickshop__variants">
            ${quickShopProduct.variants.map(
      (variant) => `
              <div
                class="product-swatches__form-group ${variant.availabilityClass}"
                ${quickShopProduct.bis_enabled && !variant.available ? "data-sold-out-toggle" : ""}
                ${quickShopProduct.bis_enabled && variant.bis_enabled ? "data-show-bis" : ""}
                data-variant-id="${variant.id}"
              >

                <div>
                  ${variant.pfand ? `
                          <span class="product-swatches__pfand">
                            Pfand: €${variant.pfand}
                          </span>
                        ` : ""}
                  <label for="variant-${variant.id}">${variant.title}</label>
                </div>

                <div class="product-swatches__price-wrapper" data-compare-price="${variant.compare_at_price}">
                  <p class="product-swatches__price">
                    ${variant.compare_at_price ? `
                      <div>
                        <span class="visually-hidden">
                          ${window.themeVars.strings.product.price.sale}
                        </span>
                        <span>
                      ${variant.real_compare_at_price ? `
                        <span class="price price__regular price--on-sale">
                          ${variant.price}
                        </span>
                      ` : `
                        <span class="price price__regular">
                          ${variant.price}
                        </span>
                      `}
                        <span>
                          <span class="price__compare-at compare-at-price">
                            ${variant.compare_at_price}
                          </span>
                        </span>
                      </div>
                    ` : `
                      <div class="price__regular">
                        <span class="visually-hidden">
                          ${window.themeVars.strings.product.price.regular}
                        </span>
                        <span class="price price__regular">
                          ${variant.price}
                        </span>
                      </div>
                    `}
                  </p>
                   <span class="product-swatches__price__per-can">
                    ${variant.price_per_can && !variant.millilitres ? `
                      <span>
                        ${variant.price_per_can}
                        ${window.themeVars.strings.product.perCan}
                      </span>
                      ` : `

                   `}
                  </span>
                </div>
                ${quickShopProduct.bis_enabled && variant.bis_enabled && variant.available == false ? `
                    <span class="product-swatches__bell-icon">
                      ${window.themeVars.icons.bell}
                    </span>
                  ` : `
                      <uwp-quantity-selector
                        data-max-quantity-message="You've reached the max quantity"
                        ${!variant.available && quickShopProduct.bis_enabled && variant.bis_enabled ? "style='display: none;'" : ""}
                      >
                        <div class="product-swatches__quantity quantity-selector quantity-selector--small">
                          <button type="button" class="minus" data-qty-button aria-label="Decrease quantity">
                            ${window.themeVars.icons.minus}
                          </button>
                          <input
                            type="number"
                            step="1"
                            min="${variant.min_quantity ?? 0}"
                            readonly
                            max="${variant.max_quantity ?? (variant.quantityAvailable || variant.inventory_quantity)}"
                            name="quantity"
                            value="${variant.min_quantity ?? 0}"
                            id="variant-${variant.id}"
                            class="quantity"
                            data-id="${variant.id}"
                            data-price="${variant.price}"
                            size="4"
                            data-qty-input
                            aria-label="Quantity input for ${variant.title}"
                            ${variant.pfand ? `data-pfand="${variant.pfand}"` : ""}
                          >

                          <button type="button" class="plus" data-qty-button aria-label="Increase quantity">
                            ${window.themeVars.icons.plus}
                          </button>
                        </div>
                      </uwp-quantity-selector>
                  `}
              </div>
            `
    ).join("")}
          </div>

          <p class="quickshop__no-quantity-message">
            ${window.themeVars.strings.product.pleaseSelectQuantity}
          </p>

          <div class="quickshop__button-wrapper">
            <button
              type="submit"
              class="quickshop__atc-button btn btn-black ${!quickShopProduct.available || allVariantsMaxedOut ? "hidden" : ""}"
              id="multipleAtcButton"
            >
              <span>
                ${window.themeVars.strings.product.addToCart}
                <span id="quickshop-subtotal"></span>
              </span>
            </button>

            ${soldOutButton}
            ${allVariantsMaxedOut ? `
            <button
              type="button"
              class="quickshop__atc-button btn btn-white"
              style="border: 1px solid #000; color: #000;"
              disabled
            >
              <span>
                You've reached the max quantity
              </span>
            </button>
            ` : ""}
          </div>
        </div>
      </div>
    `;
    this.quickShopModal.innerHTML = quickShopContent;
    document.body.appendChild(this.quickShopModal);
    (_b = (_a = this.quickShopModal) == null ? void 0 : _a.querySelector(".quickshop__close")) == null ? void 0 : _b.addEventListener("click", closeQuickShopButton);
    (_d = (_c = this.quickShopModal) == null ? void 0 : _c.querySelector(".quickshop__overlay")) == null ? void 0 : _d.addEventListener("click", closeQuickShopButton);
    const atcButton = (_e = this.quickShopModal) == null ? void 0 : _e.querySelector(
      ".quickshop__atc-button"
    );
    if (atcButton) {
      atcButton.addEventListener("click", handleAddToCart);
    }
    quickShopProduct.variants.forEach(
      (variant) => {
        var _a2, _b2;
        const decrementButton = (_a2 = this.quickShopModal) == null ? void 0 : _a2.querySelector(
          `.variant-${variant.id} .minus`
        );
        const incrementButton = (_b2 = this.quickShopModal) == null ? void 0 : _b2.querySelector(
          `.variant-${variant.id} .plus`
        );
        if (decrementButton) {
          decrementButton.addEventListener(
            "click",
            () => quantityDecrement(variant.id)
          );
        }
        if (incrementButton) {
          incrementButton.addEventListener(
            "click",
            () => quantityIncrement(variant.id)
          );
        }
      }
    );
    this.atcButton = this.quickShopModal.querySelector(
      "#multipleAtcButton"
    );
    this.soldOutToggles = [
      ...this.quickShopModal.querySelectorAll("[data-sold-out-toggle]")
    ];
    this.soldOutButton = this.quickShopModal.querySelector(
      "[data-sold-out-button]"
    );
    this.bisButton = this.quickShopModal.querySelector(
      "[data-bis-trigger]"
    );
    this.bisPopupInitial = document.querySelector(
      `uwp-product-notify-me[data-product-id="${quickShopProduct.id}"]`
    );
    const clone = (_f = this.bisPopupInitial) == null ? void 0 : _f.cloneNode(true);
    if (clone) {
      this.bisPopup = document.body.appendChild(clone);
    }
    (_g = this.soldOutToggles) == null ? void 0 : _g.forEach((toggle) => {
      toggle.addEventListener("click", this.handleSoldOutToggle.bind(this));
    });
    (_h = this.bisButton) == null ? void 0 : _h.addEventListener("click", () => {
      var _a2;
      closeQuickShopButton();
      (_a2 = this.bisPopup) == null ? void 0 : _a2.setAttribute("is-visible", "true");
    });
  }
  showATC() {
    var _a, _b;
    const selectedSoldOut = (_a = this.soldOutToggles) == null ? void 0 : _a.find(
      (toggle) => toggle.classList.contains("is-selected")
    );
    selectedSoldOut == null ? void 0 : selectedSoldOut.classList.remove("is-selected");
    const quickShopProduct = JSON.parse(
      this.getAttribute("data-product") || "{}"
    );
    if (!quickShopProduct.available) {
      return;
    }
    (_b = this.atcButton) == null ? void 0 : _b.classList.remove("hidden");
    [this.soldOutButton, this.bisButton].forEach(
      (button) => button == null ? void 0 : button.classList.add("hidden")
    );
  }
  closeQuickShop() {
    if (this.quickShopModal) {
      document.body.removeChild(this.quickShopModal);
    }
  }
}
customElements.define("uwp-quickshop-button", QuickShopButton);
